import React from 'react';
import { type CategoryConfig, ImageType, TemplateId } from '@types';
import { $tourData } from '@stores/dataStores';
import { $editingCategoryConfig } from '@stores/editingStores';
import Image from '@components/Image';
import { getTemplateConfig } from '@utils/templateConfig';
import useLangString from '@hooks/useLangString';
import useEditingStore from '@hooks/useEditingStore';

function WCategoryBtnREAWrapper() {
  const categoryConfig = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.categoryConfig,
    $editing: $editingCategoryConfig.store,
  });
  if (!categoryConfig?.enabledColumn) return null;
  return <WCategoryBtnREA config={categoryConfig} />;
}

function WCategoryBtnREA({ config }: { config: CategoryConfig }) {
  const lang = useLangString({ title: ['场景', 'List'] }, []);
  const defaultSrc =
    getTemplateConfig(TemplateId.realEstateA)('categroyConfigIcon').icon ?? '';
  const src = config.buttonMediaUrl || defaultSrc;
  const type =
    config.buttonMediaId && config.buttonMediaUrl
      ? ImageType.media
      : ImageType.sysMedia;
  const title = config.buttonTitle || lang.title;
  return (
    <div className="absolute right-30 bottom-24 flex h-60 w-60 flex-col items-center justify-center rounded bg-white">
      <Image style={{ width: 24, height: 24 }} alt="" src={src} type={type} />
      <div className="mt-4 w-full truncate px-5 text-center text-black">
        {title}
      </div>
    </div>
  );
}

export default WCategoryBtnREAWrapper;
